import {Component, ComponentFactoryResolver, EventEmitter, OnInit} from '@angular/core';
import {FieldDefinition} from '@shared/models/field-definition';
import {DialogService} from '@shared/services/dialog-service';
import {MatDialog} from '@angular/material/dialog';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {Store} from '@ngrx/store';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'particle-treaty-cell-component',
  templateUrl: './treaty-button-cell-component.component.html',
  styleUrls: ['./treaty-button-cell-component.component.scss']
})
export class TreatyButtonCellComponentComponent implements OnInit {
  item: any;
  fieldDefinition: FieldDefinition;
  constructor(private dialogService: DialogService,
              private componentFactoryResolver: ComponentFactoryResolver) {
  }

  ngOnInit() {
  }



  navigateToTreaty() {

  }
}
